/**
 * biofit-fd-bundle.js — Father's Day Bundle shared utilities
 * Picker logic lives inline in biofit-fd-picker.liquid (avoids defer conflicts).
 * This file handles: countdown timer, scroll CTA.
 * Vanilla JS / ES5 compatible.
 */
(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initCountdowns();
    initScrollCta();
  }

  /* ─── Countdown timer (multiple on page) ─────────────────── */
  function initCountdowns() {
    document.querySelectorAll('.fd-countdown').forEach(function (el) {
      var deadline = new Date(el.getAttribute('data-deadline'));
      function tick() {
        var now  = new Date();
        var diff = deadline - now;
        if (diff <= 0) {
          var wrap = el.closest('.fd-banner');
          if (wrap) wrap.style.display = 'none';
          return;
        }
        var days  = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins  = Math.floor((diff % 3600000)  / 60000);
        var secs  = Math.floor((diff % 60000)    / 1000);
        setText(el, '[data-days]',  pad(days));
        setText(el, '[data-hours]', pad(hours));
        setText(el, '[data-mins]',  pad(mins));
        setText(el, '[data-secs]',  pad(secs));
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  function setText(root, selector, val) {
    var el = root.querySelector(selector);
    if (el) el.textContent = val;
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* ─── Scroll CTA ─────────────────────────────────────────── */
  function initScrollCta() {
    document.querySelectorAll('.fd-hero__scroll-cta').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById('fd-picker-anchor');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

})();
